import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  format,
} from "date-fns";
import { now } from "./now";
import { parseDate } from "./parseDate";

export const formatNotificationTimestamp = (
  dateString: string | undefined,
): string => {
  if (!dateString) return "";

  const date = parseDate(dateString);
  const currentTime = now();
  const diffInMinutes = differenceInMinutes(currentTime, date);
  const diffInHours = differenceInHours(currentTime, date);
  const diffInDays = differenceInDays(currentTime, date);

  if (diffInMinutes < 1) {
    return "Just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  } else if (diffInDays <= 7) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  } else {
    return format(date, "MM/dd/yyyy hh:mm a");
  }
};
